import {
    FETCH_CURRENT_PAGE,
    FETCH_DATATRANSFERS_REQUEST,
    FETCH_DATATRANSFERS_SUCCESS,
    FETCH_DATATRANSFERS_FAILED,
    FETCH_DATATRANSFERS_RESOURCEID_REQUEST,
    FETCH_DATATRANSFERS_RESOURCEID_SUCCESS,
    FETCH_DATATRANSFERS_RESOURCEID_FAILED
} from './mutation-type'

const mutations = {
    [FETCH_CURRENT_PAGE]: (state, { data }) => {
        state.pageObj.currentPage = data
    },
    [FETCH_DATATRANSFERS_REQUEST]: state => {
        state.status.common = 'loading'
    },
    [FETCH_DATATRANSFERS_SUCCESS]: (state, { status, data }) => {
        state.status.common = status
        state.pageObj.currentPage = 1
        if (status !== 204) {
            const { inOutDates, transferItems, transferResourceIds } = data
            state.inOutDates = inOutDates || []
            state.transferItems = transferItems || []
            const totalRows = transferResourceIds?.[0]?.resourceIds.length ?? 0
            state.lengthsOfTransferResourceIds = totalRows
            if (totalRows) {
                const resourceIds = transferResourceIds[0].resourceIds
                const rowPerPage = state.pageObj.perPage
                const totalPages = Math.ceil(totalRows / rowPerPage)
                state.splitedTransferResourceIds = Array.from({ length: totalPages }, (_, index) => {
                    return resourceIds.splice(0, rowPerPage).map(item => ({
                        ...item,
                        children: [],
                        showChildren: false
                    }))
                })
                state.checkboxModels = transferResourceIds[0].resourceIds.reduce((acc, cur) => ({ ...acc, [cur.resourceId]: false }), {})
            }
        } else {
            state.inOutDates = []
            state.transferItems = []
            state.splitedTransferResourceIds = []
            state.checkboxModels = {}
            state.lengthsOfTransferResourceIds = 0
        }
    },
    [FETCH_DATATRANSFERS_FAILED]: (state, error) => {
        state.status.common = 'error'
    },
    [FETCH_DATATRANSFERS_RESOURCEID_REQUEST]: state => {
        state.status.detail = 'loading'
    },
    [FETCH_DATATRANSFERS_RESOURCEID_SUCCESS]: (state, { status, data, index }) => {
        state.status.detail = status
        if (status !== 204) {
            state.splitedTransferResourceIds[state.pageObj.currentPage - 1][index].children = data
            state.splitedTransferResourceIds[state.pageObj.currentPage - 1][index].showChildren = !state.splitedTransferResourceIds[state.pageObj.currentPage - 1][index].showChildren
        }
    },
    [FETCH_DATATRANSFERS_RESOURCEID_FAILED]: (state, error) => {
        state.status.detail = 'error'
    }
}

export default mutations
